<template>
  <div class="login">
    <div class="login__container">
      <router-link to="/">Back</router-link>
      <h1 class="login__title">{{ $t("nav.sendLead") }}</h1>
      <form @submit.prevent="handleSubmit">
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'first_name'"
            :label="'first_name'"
            :type="'first_name'"
            :placeholder="'First Name'"
            :error-messages="validationErrors['firstName']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'last_name'"
            :label="'last_name'"
            :type="'last_name'"
            :placeholder="'Last Name'"
            :error-messages="validationErrors['lastName']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'email'"
            :label="'email'"
            :type="'email'"
            :placeholder="'Email'"
            :error-messages="validationErrors['email']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'phone'"
            :label="'phone'"
            :type="'phone'"
            :placeholder="'Phone'"
            :error-messages="validationErrors['phone']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'campaign_external'"
            :label="'campaign_external'"
            :type="'campaign_external'"
            :placeholder="'campaign external'"
            :error-messages="validationErrors['campaignExternal']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'campaign_internal'"
            :label="'campaign_internal'"
            :type="'campaign_internal'"
            :placeholder="'campaign internal'"
            :error-messages="validationErrors['campaignInternal']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'referrer_url'"
            :label="'referrer_url'"
            :type="'referrer_url'"
            :placeholder="'Referrer Url'"
            :error-messages="validationErrors['referrerUrl']"
            isBordered
            isAverage
          />
        </div>
        <div class="input-container">
          <InputText
            :set-value="formDataToSend"
            :id="'lang'"
            :label="'lang'"
            :type="'lang'"
            :placeholder="'Lang'"
            :error-messages="validationErrors['lang']"
            isBordered
            isAverage
          />
        </div>
        <div v-if="error.message != undefined" class="form-create__error">
          {{ error.message }}
        </div>
        <MainButton :type="'submit'"> SEND </MainButton>
      </form>
    </div>
    <FetchSpinnerModal v-if="loadingProcess" />
  </div>
</template>

<script>
import leadApi from "~/api/lead";

import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";

export default {
  name: "Login",
  metaInfo: {
    title: "Login",
  },
  data() {
    return {
      formDataToSend: {
        email: null,
        first_name: null,
        last_name: null,
        phone: "",
        referrer_url: "https://test-url.com",
        campaign_external: null,
        campaign_internal: null,
        lang: null,
      },
      error: {},
      validationErrors: {},
      loadingProcess: false,
    };
  },
  methods: {
    handleSubmit() {
      const data = this.formDataToSend;

      this.loadingProcess = true;
      leadApi
        .createLead(data)
        .then((res) => {
          this.loadingProcess = false;
          alert("success");
        })
        .catch((error) => {
          this.loadingProcess = false;
          const { data } = error.response;
          if (data.errors) {
            this.validationErrors = data.errors;
          }
        });
    },
  },

  components: {
    MainButton,
    InputText,
    FetchSpinnerModal,
  },
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  &__container {
    width: 400px;
    padding-bottom: 150px;
  }

  &__title {
    padding-bottom: 20px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    color: $coffee;
  }

  &__choose-site {
    padding: 10px 0;
    display: flex;
    justify-content: center;
  }
}
.input-container {
  padding-bottom: 20px;
}
</style>
